module.exports = __webpack_public_path__ + "static/Disclaimer-45f0e785361d6ffcfb2eb42df0f571e5.png";